import Svg, { G, Path } from 'react-native-svg'

export const JpbRupeeSymbol = () => {
  return (
    <Svg id="Symbols" width="32" height="32" viewBox="0 0 32 32">
      <G id="Images_Logos_JioPrime_Light" data-name="Images/Logos/JioPrime/Light" transform="translate(0 0)">
        <G id="Group-2">
          <G id="Group-9">
            <Path
              id="Subtraction_1"
              data-name="Subtraction 1"
              d="M16,32A16,16,0,0,1,4.686,4.686,16,16,0,1,1,27.314,27.314,15.9,15.9,0,0,1,16,32Zm7.7-19.662c-3.007,0-5.027,1.917-5.027,4.769a4.728,4.728,0,0,0,1.346,3.5,5.079,5.079,0,0,0,3.625,1.3,5.143,5.143,0,0,0,3.637-1.3,4.667,4.667,0,0,0,1.372-3.485A4.692,4.692,0,0,0,27.3,13.655,5.037,5.037,0,0,0,23.7,12.338ZM5.411,17.69a1.9,1.9,0,0,0-1.2,1.848c0,1.51,1.436,2.375,3.94,2.375A4.756,4.756,0,0,0,11.7,20.7a5.249,5.249,0,0,0,1.208-3.779V11.363c0-1.136-.539-1.713-1.6-1.713H10.77c-1.024,0-1.565.592-1.565,1.713v5.506c0,1.378-.449,1.915-1.6,1.915A2.714,2.714,0,0,1,5.431,17.7.025.025,0,0,0,5.411,17.69Zm10.346-5.26c-1.051,0-1.584.576-1.584,1.713v5.892c0,1.168.515,1.713,1.621,1.713h.367c1.026,0,1.547-.576,1.547-1.713V14.143c0-1.184-.488-1.713-1.584-1.713Zm.166-4.272a1.638,1.638,0,0,0-1.859,1.658c0,1.033.733,1.675,1.914,1.675a1.646,1.646,0,0,0,1.861-1.675C17.838,8.794,17.1,8.158,15.922,8.158Zm7.745,11.048a1.958,1.958,0,0,1-1.989-2.1,1.991,1.991,0,1,1,3.976.019A1.991,1.991,0,0,1,23.667,19.207Z"
              fill="#1386b0"
            />
          </G>
        </G>
      </G>
    </Svg>
  )
}
